import { useEffect } from 'react';
import { getScrollbarWidth } from '../utils/dom/dom';

const useDisableScroll = (isEnabled = true) => {
  useEffect(() => {
    if (isEnabled) {
      const scrollbarWidth = getScrollbarWidth();

      if (scrollbarWidth) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }

      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [isEnabled]);

  return isEnabled;
};

export default useDisableScroll;
